import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51a28474"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["textContent"]
const _hoisted_2 = { class: "learning-calendar" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: 0,
  class: "day-icon"
}

import { formatMonth } from "@/filters/filters";
import { CalendarData, CalendarDay } from "@/models/calendar";
import { Learning } from "@/models/learning";
import { isSameDay } from "date-fns";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LearningCalendar',
  props: {
  learnings: {
    type: Array as PropType<Learning[]>,
    required: true
  },
  calendar: {
    type: Object as PropType<CalendarData>,
    required: true
  }
},
  emits: ["edit"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const hasLearning = (day: CalendarDay): boolean => {
  return props.learnings.some((l) =>
    isSameDay(new Date(l.date), new Date(day.internal))
  );
};

const edit = (day: CalendarDay) => {
  emit("edit", {
    ...day,
    learnings: props.learnings.filter((l) =>
      isSameDay(new Date(l.date), new Date(day.internal))
    )
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", {
      textContent: _toDisplayString(_unref(formatMonth)(__props.calendar.start))
    }, null, 8, _hoisted_1),
    _createElementVNode("div", null, [
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.calendar.days, (day) => {
          return (_openBlock(), _createElementBlock("li", {
            onClick: ($event: any) => (edit(day)),
            class: _normalizeClass({
          day: true,
          'day-previous': day.is_previous,
          'day-next': day.is_next,
          'day-learned': hasLearning(day)
        })
          }, [
            _createElementVNode("span", {
              class: "day-date",
              textContent: _toDisplayString(day.day)
            }, null, 8, _hoisted_4),
            (hasLearning(day))
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "✓"))
              : _createCommentVNode("", true)
          ], 10, _hoisted_3))
        }), 256))
      ])
    ])
  ], 64))
}
}

})